import { useInsuranceReportShallowStore } from '@frontend/insurance-eligibility-report-tuuthfairy';
import { useInterRouter } from '@frontend/settings-routing';
import { VerticalSlideModal, useVerticalSlideModal } from '@frontend/design-system';
import { useInsuranceTabShallowStore } from '../stores/use-insurance-tab-store';
import { INLINE_REPORT_MODAL_ID } from '../utils/constants';

export const InsuranceReportModalContainer = ({
  isOpen,
  setIsOpen,
  children,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const { insuranceReportModalState, setIsPersonId } = useInsuranceReportShallowStore(
    'insuranceReportModalState',
    'setIsPersonId'
  );
  const { setShouldReportOpenInLargeModeSwitch } = useInsuranceTabShallowStore('setShouldReportOpenInLargeModeSwitch');
  const { isSettingsOpen } = useInterRouter(['isSettingsOpen']);

  const { modalProps } = useVerticalSlideModal({
    open: shouldShowReport(isOpen, isSettingsOpen),
    onOpenChange: () => {
      insuranceReportModalState.setSearchValue('');
      insuranceReportModalState.setFilterValue('');
      setIsPersonId('');
      setShouldReportOpenInLargeModeSwitch(false); //reset the opening of report when switched to large mode when modal is closed
      setIsOpen(false);
    },
    outsidePress: (e) => {
      setIsPersonId('');
      return (e.target as HTMLElement).id === INLINE_REPORT_MODAL_ID;
    },
  });

  return (
    <VerticalSlideModal {...modalProps} backdropOverlayId={INLINE_REPORT_MODAL_ID}>
      <VerticalSlideModal.Content>{children}</VerticalSlideModal.Content>
    </VerticalSlideModal>
  );
};

const shouldShowReport = (isReportOpen: boolean, isSettingsOpen: boolean) => {
  //to prevent both modals from being open at the same time. only one modal should be open at a time  when settings modal is open report modal should be closed
  if (isReportOpen && isSettingsOpen) {
    return false;
  }
  return isReportOpen;
};
